import React, { memo } from 'react'
import { CheckOutlineIcon, ClockIcon, WarningIcon, CloseIcon } from 'transfix-icons'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'

interface IStatusTagProps {
  status?: string | null
}

export const StatusTag = memo<IStatusTagProps>(({ status }) => {
  switch (status) {
    case 'success':
      return (
        <Tag
          label='Complete'
          icon={<CheckOutlineIcon size='large' />}
          size={TAG_SIZE.small}
          tagStyle={TAG_STYLE.success}
        />
      )
    case 'pending':
      return (
        <Tag
          label='In Progress'
          icon={<ClockIcon size='large' />}
          size={TAG_SIZE.small}
          tagStyle={TAG_STYLE.info}
        />
      )
    case 'failure':
      return (
        <Tag
          label='Failure'
          icon={<CloseIcon size='large' />}
          size={TAG_SIZE.small}
          tagStyle={TAG_STYLE.error}
        />
      )
    case 'error':
      return (
        <Tag
          label='Error'
          icon={<WarningIcon size='large' />}
          size={TAG_SIZE.small}
          tagStyle={TAG_STYLE.warning}
        />
      )
    default:
      // Status could be null when RFPs are too old
      // to have an associated norm job. In this case,
      // treat them as complete:
      return (
        <Tag
          label='Complete'
          icon={<CheckOutlineIcon size='large' />}
          size={TAG_SIZE.small}
          tagStyle={TAG_STYLE.success}
        />
      )
  }
})
